"use strict";
if (typeof Iterator === 'undefined' && typeof globalThis === 'object') {
    class Iterator {
        [Symbol.iterator]() {
            return this;
        }
        find(predicate) {
            for (const value of this)
                if (predicate(value))
                    return value;
            return;
        }
    }
    /**
     * The `Iterator` global class is new, so we need to check if it exists.
     */
    globalThis.Iterator = Iterator;
}
